import type { Role, RoleModificators } from '@/domain/env/schemas';

const isAccountant = ({ role }: { role: Role | null }) => role === 'accountant';

// The roles a restricted modificator applies to; a supplier's is ignored.
const RESTRICTABLE_ROLES: ReadonlyArray<Role> = ['accountant', 'user', 'confidential-user'];

const isRestricted = ({ role, restricted }: { role: Role | null } & Pick<RoleModificators, 'restricted'>) =>
  role !== null && RESTRICTABLE_ROLES.includes(role) && restricted;

/**
 * The role model of an organization user — base role, modificators and how they combine — as the
 * `organization-user-role-model` specification defines it. What a modificator withholds is stated there, not here.
 */
export const roleModel = { isAccountant, isRestricted };
